module.exports = __webpack_public_path__ + "media/images/main-bg-1c16c32a5b92e1ccaa7b7b02ebc0c19c.jpg";